module.exports = __webpack_public_path__ + "img/punch-y.363ec281.png";